/* HAND-AUTHORED (the artifact pipeline was unavailable for this scene) — film scene "f-memory".
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. */

import type { FilmScene } from '../../types';

export const F_MEMORY: FilmScene = {
  "w": 640,
  "h": 300,
  "items": [
    {
      "k": "frame",
      "id": "conv",
      "x": 14,
      "y": 16,
      "w": 186,
      "h": 268,
      "lKey": "films:f-memory.items.conv.l"
    },
    {
      "k": "box",
      "id": "t1",
      "x": 26,
      "y": 48,
      "w": 162,
      "h": 44,
      "lKey": "films:f-memory.items.t1.l"
    },
    {
      "k": "box",
      "id": "t2",
      "x": 26,
      "y": 104,
      "w": 162,
      "h": 44,
      "lKey": "films:f-memory.items.t2.l"
    },
    {
      "k": "box",
      "id": "t3",
      "x": 26,
      "y": 160,
      "w": 162,
      "h": 56,
      "lKey": "films:f-memory.items.t3.l",
      "sKey": "films:f-memory.items.t3.s"
    },
    {
      "k": "wire",
      "id": "wb",
      "from": "t2",
      "to": "sum",
      "dash": true
    },
    {
      "k": "frame",
      "id": "store",
      "x": 222,
      "y": 16,
      "w": 180,
      "h": 200,
      "lKey": "films:f-memory.items.store.l"
    },
    {
      "k": "box",
      "id": "sum",
      "x": 234,
      "y": 48,
      "w": 156,
      "h": 52,
      "lKey": "films:f-memory.items.sum.l"
    },
    {
      "k": "wire",
      "id": "wa",
      "from": "t3",
      "to": "sum"
    },
    {
      "k": "box",
      "id": "prof",
      "x": 234,
      "y": 116,
      "w": 156,
      "h": 52,
      "lKey": "films:f-memory.items.prof.l"
    },
    {
      "k": "bar",
      "id": "win",
      "x": 234,
      "y": 180,
      "w": 156,
      "h": 14,
      "v": 0.3,
      "lKey": "films:f-memory.items.win.l"
    },
    {
      "k": "wire",
      "id": "wc",
      "from": "sum",
      "to": "pr"
    },
    {
      "k": "wire",
      "id": "wd",
      "from": "prof",
      "to": "pr"
    },
    {
      "k": "box",
      "id": "pr",
      "x": 432,
      "y": 62,
      "w": 192,
      "h": 64,
      "lKey": "films:f-memory.items.pr.l",
      "sKey": "films:f-memory.items.pr.s"
    },
    {
      "k": "wire",
      "id": "we",
      "from": "pr",
      "to": "an"
    },
    {
      "k": "box",
      "id": "an",
      "x": 432,
      "y": 150,
      "w": 192,
      "h": 64,
      "lKey": "films:f-memory.items.an.l",
      "sKey": "films:f-memory.items.an.s"
    },
    {
      "k": "note",
      "id": "cite",
      "x": 432,
      "y": 234,
      "lKey": "films:f-memory.items.cite.l"
    }
  ],
  "steps": [
    {
      "on": [
        "conv",
        "t1",
        "t2",
        "t3"
      ],
      "hot": [
        "conv"
      ],
      "capKey": "films:f-memory.steps.0.cap"
    },
    {
      "on": [
        "conv",
        "t1",
        "t2",
        "t3",
        "store",
        "sum",
        "wb",
        "wa"
      ],
      "hot": [
        "sum",
        "wa"
      ],
      "capKey": "films:f-memory.steps.1.cap"
    },
    {
      "on": [
        "conv",
        "t1",
        "t2",
        "t3",
        "store",
        "sum",
        "wb",
        "wa",
        "prof"
      ],
      "hot": [
        "prof"
      ],
      "capKey": "films:f-memory.steps.2.cap"
    },
    {
      "on": [
        "conv",
        "t1",
        "t2",
        "t3",
        "store",
        "sum",
        "wb",
        "wa",
        "prof",
        "win",
        "pr",
        "wc",
        "wd"
      ],
      "hot": [
        "win",
        "wc",
        "wd"
      ],
      "capKey": "films:f-memory.steps.3.cap"
    },
    {
      "on": [
        "conv",
        "t1",
        "t2",
        "t3",
        "store",
        "sum",
        "wb",
        "wa",
        "prof",
        "win",
        "pr",
        "wc",
        "wd",
        "an",
        "we",
        "cite"
      ],
      "hot": [
        "an",
        "cite"
      ],
      "capKey": "films:f-memory.steps.4.cap"
    }
  ]
};